import EXPERT_CATEGORIES from "./expertCategories";

export default value => {
    const data = EXPERT_CATEGORIES.find((i) => i.value === value);

    return data ? data.text : "N/A";
}
